export default "__VITE_ASSET__cf9ba83b__"